import AlternateEmailRoundedIcon from '@mui/icons-material/AlternateEmailRounded';
import { Button, Stack, Typography } from '@mui/material';
import tokens from '@verifime/design-tokens';
import { ColoredIcon } from '../ColoredIconAndChip';
import { OrganisationUser } from './type';

interface OrganisationUserListItemProps<T extends OrganisationUser> {
  item: T;
  AdditionalItem?: React.FC<T>;
  onRemoveUser: (user: T) => void;
}

export default function OrganisationUserListItem<T extends OrganisationUser>({
  item,
  AdditionalItem,
  onRemoveUser,
}: Readonly<OrganisationUserListItemProps<T>>) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      gap={tokens.spacing2xs}
      flexWrap="wrap"
      role="listitem"
      data-record-detail={item.email}
    >
      <Stack direction="row" alignItems="center" gap={tokens.spacing2xs} flexWrap="wrap">
        <AlternateEmailRoundedIcon aria-hidden="true" sx={{ fontSize: 12 }} />
        <Typography>{item.email}</Typography>
        {AdditionalItem && <AdditionalItem {...item} />}
      </Stack>
      <Button
        variant="text"
        startIcon={<ColoredIcon iconName="deleteRounded" />}
        onClick={() => {
          onRemoveUser(item);
        }}
        color="error"
        aria-label="remove"
        data-action="remove-user"
      />
    </Stack>
  );
}
